// extracted by css-extract-rspack-plugin
export default {"noWidow":"noWidow__RiCpc"};